// import React, { useState } from 'react';

function BuyMeCoffee() {
  // const [showText, setShowText] = useState(false);

  return (
    <div className="text-center py-8">
      <a href="https://www.buymeacoffee.com/immanuwell" target="_blank" rel="noreferrer" style={{ textDecoration:'none', position: 'relative', padding: '0 0', textAlign: 'center', marginTop:'0', display: 'inline-block' }}>
        <button
          // onClick={() => setShowText(!showText)}
          className="bg-blue-300 text-white px-6 py-2 rounded-lg hover:bg-blue-500 transition-colors"
        >
          <strong>Buy me a coffee</strong>
        </button>
      </a>
    
      {/* {showText && (
        <p className="text-sm md:text-base mt-4 text-gray-600">
          <strong>Bitcoin:</strong><br></br>
          bc1qs5q9gz3cjfd7mffl29txhgeks26j2gjpcfg7fm<br></br>
          
          <br></br>
          <strong>Etherium:</strong><br></br>
          0x4A67A83000422745c15cbb690BEf048895F55266
        </p>
      )} */}

    </div>
  );
}

export default BuyMeCoffee;
